import React from "react";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import FileDownloadOutlined from "@mui/icons-material/FileDownloadOutlined";

export type PaymentCountFilter = "all" | "multiple" | "single" | string;
export type ClientCountFilter = "all" | "compassAndOther" | string;

export interface DetailsExportClusterProps {
  paymentCountFilter: PaymentCountFilter;
  onPaymentCountFilterChange: (event: SelectChangeEvent) => void;
  clientCountFilter: ClientCountFilter;
  onClientCountFilterChange: (event: SelectChangeEvent) => void;
  onDownload: () => void;
  loading: boolean;
  buttonLabel: string;
}

/**
 * The payment-details CSV export of the 1099 screens (Payments and Payments 2025): its two
 * filters sit with its button because they only shape that CSV, not the table.
 */
export function DetailsExportCluster({
  paymentCountFilter,
  onPaymentCountFilterChange,
  clientCountFilter,
  onClientCountFilterChange,
  onDownload,
  loading,
  buttonLabel,
}: DetailsExportClusterProps) {
  return (
    <Box
      role="group"
      aria-labelledby="details-export-label"
      sx={{
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 2,
      }}
    >
      <Typography
        id="details-export-label"
        variant="caption"
        sx={{
          color: "text.secondary",
          fontWeight: 500,
          textTransform: "uppercase",
          letterSpacing: "0.06em",
        }}
      >
        Details export
      </Typography>
      <FormControl size="small" sx={{ minWidth: 150 }}>
        <InputLabel id="payment-count-filter-label">Payment Filter</InputLabel>
        <Select
          labelId="payment-count-filter-label"
          id="payment-count-filter"
          value={paymentCountFilter}
          label="Payment Filter"
          onChange={onPaymentCountFilterChange}
        >
          <MenuItem value="all">All Payments</MenuItem>
          <MenuItem value="multiple">Multiple Payments</MenuItem>
          <MenuItem value="single">Single Payment</MenuItem>
        </Select>
      </FormControl>
      <FormControl size="small" sx={{ minWidth: 180 }}>
        <InputLabel id="client-count-filter-label">Client Filter</InputLabel>
        <Select
          labelId="client-count-filter-label"
          id="client-count-filter"
          value={clientCountFilter}
          label="Client Filter"
          onChange={onClientCountFilterChange}
        >
          <MenuItem value="all">All Clients</MenuItem>
          <MenuItem value="compassAndOther">Compass + Other</MenuItem>
        </Select>
      </FormControl>
      <LoadingButton
        variant="outlined"
        size="small"
        startIcon={<FileDownloadOutlined />}
        onClick={onDownload}
        loading={loading}
        loadingPosition="start"
        sx={{ whiteSpace: "nowrap" }}
      >
        {buttonLabel}
      </LoadingButton>
    </Box>
  );
}

export default DetailsExportCluster;
